import { render } from "./BMICalculationItemWeight.vue?vue&type=template&id=14185e72&ts=true"
import script from "./BMICalculationItemWeight.vue?vue&type=script&lang=ts"
export * from "./BMICalculationItemWeight.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__